import {
    WorkbenchPlugin,
    WorkbenchPluginId, WorkbenchViewKind
} from '../../shared/types';
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {faUniversalAccess} from "@fortawesome/pro-solid-svg-icons";
import {WCAGAnalysisViewComponent} from "../analysis/views/wcag-analysis-view.component";
import {TabOrderAnalysisComponent} from "../analysis/views/tab-order-analysis.component";
import {ImpairedVisionSimulationControlViewComponent} from "./views/impaired-vision-simulation-control-view.component";
import {A11yInteractivePageToolsViewComponent} from "./views/a11y-interactive-page-tools-view.component";
import {WorkbenchCommandRegistry} from "../../shared/services/workbench-command-registry.service";
import {WorkbenchLayoutManager} from "../../shared/services/workbench-layout-manager.service";

@Injectable()
export class A11yToolsPlugin extends WorkbenchPlugin {
    id: WorkbenchPluginId = 'a11y-tools';
    views: WorkbenchViewKind[];

    static readonly WCAGAnalysisViewId = 'a11y-tools.view.wcag-analysis';
    static readonly InteractivePageToolsViewId = 'a11y-tools.view.interactive-page-tools';
    static readonly ImpairedVisionSimulationViewId = 'a11y-tools.view.impaired-vision-simulation';
    static readonly TabOrderAnalysisViewId = 'a11y-tools.view.tabOrderAnalysis';

    private viewContainerId = 'a11y-tools.viewcontainer';

    constructor(private commandRegistry: WorkbenchCommandRegistry,
                readonly layoutManager: WorkbenchLayoutManager) {
        super(layoutManager);
        this.views = [
            {
                id: A11yToolsPlugin.WCAGAnalysisViewId,
                component: WCAGAnalysisViewComponent,
                name: 'WCAG Automation',
                defaultViewContainer: this.viewContainerId,
                visibility: 'generic',
            },
            {
                id: A11yToolsPlugin.InteractivePageToolsViewId,
                component: A11yInteractivePageToolsViewComponent,
                name: 'Interactive Page Tools',
                defaultViewContainer: this.viewContainerId,
                visibility: 'generic',
            },
            {
                id: A11yToolsPlugin.ImpairedVisionSimulationViewId,
                component: ImpairedVisionSimulationControlViewComponent,
                name: 'Impaired Vision Simulation',
                defaultViewContainer: this.viewContainerId,
                visibility: 'generic',
            },
            {
                id: A11yToolsPlugin.TabOrderAnalysisViewId,
                component: TabOrderAnalysisComponent,
                name: 'Tab Order Analysis (Beta)',
                defaultViewContainer: this.viewContainerId,
                visibility: 'generic',
            }
        ];
    }

    onWorkbenchDestroy(): void {
    }

    onWorkbenchInit(): Observable<void> {
        this.layoutManager.registerViewContainer({
            type: 'NormalViewContainer',
            id: this.viewContainerId,
            name: 'Accessibility Tools',
            icon: {
                type: 'faIcon',
                instance: faUniversalAccess
            },
            allowedPanels: ['left-top', 'left-bottom'],
            defaultPanel: 'left-top',
            displayMode: 'stacked',
            toolbarCommandId: 'a11y-tools:toggleViewContainer'
        });

        this.commandRegistry.registerCommand(
            'a11y-tools:toggleViewContainer',
            {
                name: 'Accessibility Tools',
                icon: {
                    type: 'faIcon',
                    instance: faUniversalAccess
                },
                description: 'Toggle Accessibility Tools',
                statusBindings: {
                    'active': {
                        'type': 'store',
                        'storeKey': 'viewcontainers.a11y-tools.viewcontainer.status.visible',
                    }
                }
            },
            () => {
                this.layoutManager.toggleViewContainer('a11y-tools.viewcontainer', true);
            }
        );

        return of(undefined);
    }
}
